var s={icon:"lds-icon",svg:"lds-icon--svg"};export{s as default};
